import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useRouter } from '@/lib/navigation';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';

export default function Paywall() {
  const { colors } = useTheme();
  const router = useRouter();

  useEffect(() => {
    router.replace('/pricing');
  }, [router]);

  return (
    <View style={[styles.container, { backgroundColor: colors.solid_color_primary }] }>
      <View style={styles.center}>
        <Text size="n" color="secondary">Redirecting to pricing...</Text>
        <Button text="Go To Pricing" variant="primary" onPress={() => router.replace('/pricing')} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 20,
    paddingVertical: 40,
  },
  center: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 4,
  },
}); 